/* tslint:disable */

declare var Object: any;
export interface ERPsalesReturnInterface {
  "id"?: number;
}

export class ERPsalesReturn implements ERPsalesReturnInterface {
  "id": number;
  constructor(data?: ERPsalesReturnInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPsalesReturn`.
   */
  public static getModelName() {
    return "ERPsalesReturn";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPsalesReturn for dynamic purposes.
  **/
  public static factory(data: ERPsalesReturnInterface): ERPsalesReturn{
    return new ERPsalesReturn(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPsalesReturn',
      plural: 'ERPsalesReturns',
      path: 'ERPsalesReturns',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPsalesReturn.ts